@keyframes appear {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Waits before appearing, so a fast load never flashes a spinner. */
.root {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-4);
  min-block-size: min(24rem, 50vh);
  padding: var(--space-8) var(--space-4);
  animation: appear var(--motion-duration-short4) var(--motion-easing-standard)
    var(--motion-duration-medium2) both;
}

.spinner {
  color: var(--md-primary);
}

.label {
  font: var(--type-body-md);
  letter-spacing: var(--tracking-body-md);
  color: var(--md-on-surface-variant);
}
